module.exports = __webpack_public_path__ + "img/chen_sc2.53ffae09.png";